
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";

const ROUTEBUS = {
  primary: "#FFB000",
  primaryHover: "#FFB000",
  primaryLight: "#FFF5D9",
  primaryDark: "#FFB000",
  navy: "#26364B",
  navyText: "#142B50",
  white: "#FFFFFF",
  background: "#F8FAFC",
  darkBackground: "#0F172A",
  darkSurface: "#1E293B",
};

const lightColors = {
  primary: ROUTEBUS.primary,
  "on-primary": "#000000",

  "primary-darken-1": ROUTEBUS.primary,
  "primary-lighten-1": ROUTEBUS.primary,

  background: ROUTEBUS.background,
  surface: ROUTEBUS.white,
  grey: "#F8FAFC",

  "on-background": "#0F172A",
  "on-surface": "#0F172A",

  secondary: "#64748B",
  "on-secondary": "#FFFFFF",

  "surface-variant": "#F1F5F9",
  "on-surface-variant": "#475569",

  outline: "#E2E8F0",

  success: "#16A34A",
  "on-success": "#FFFFFF",

  warning: "#D49A35",
  "on-warning": "#172033",

  error: "#DC2626",
  "on-error": "#FFFFFF",

  info: "#2563EB",
  "on-info": "#FFFFFF",

  blue: "#2563EB",
  violet: "#7C3AED",

  "rb-navy": ROUTEBUS.navy,
  "rb-navy-light": "#34465D",

  "rb-text": ROUTEBUS.navyText,
  "rb-muted": "#64748B",
  "rb-border": "#E6EBF2",

  "rb-sidebar-bg": "#FFFFFF",
  "rb-sidebar-text": "#26364B",
  "rb-sidebar-muted": "#64748B",

  "rb-sidebar-hover": "#FFFAF0",
  "rb-sidebar-active": ROUTEBUS.primaryLight,
  "rb-sidebar-active-text": "#785000",
  "rb-sidebar-line": "#E2E8F0",

  "rb-primary-hover": ROUTEBUS.primary,
  "rb-primary-light": ROUTEBUS.primaryLight,
  "rb-primary-dark": ROUTEBUS.primary,
};

const darkColors = {
  primary: ROUTEBUS.primary,
  "on-primary": "#000000",

  "primary-darken-1": ROUTEBUS.primary,
  "primary-lighten-1": ROUTEBUS.primary,

  background: ROUTEBUS.darkBackground,
  surface: ROUTEBUS.darkSurface,
  grey: "#111827",

  "on-background": "#F8FAFC",
  "on-surface": "#F8FAFC",

  secondary: "#94A3B8",
  "on-secondary": "#0F172A",

  "surface-variant": "#334155",
  "on-surface-variant": "#CBD5E1",

  outline: "#475569",

  success: "#22C55E",
  "on-success": "#052E16",

  warning: "#E4B75C",
  "on-warning": "#422006",

  error: "#F87171",
  "on-error": "#450A0A",

  info: "#60A5FA",
  "on-info": "#172554",

  blue: "#60A5FA",
  violet: "#A78BFA",

  "rb-navy": ROUTEBUS.navy,
  "rb-navy-light": "#34465D",

  "rb-text": "#F1F5F9",
  "rb-muted": "#94A3B8",
  "rb-border": "#475569",

  "rb-sidebar-bg": "#1E293B",
  "rb-sidebar-text": "#F1F5F9",
  "rb-sidebar-muted": "#94A3B8",

  "rb-sidebar-hover": "#29384A",
  "rb-sidebar-active": "#483A1B",
  "rb-sidebar-active-text": "#FFC247",
  "rb-sidebar-line": "#475569",

  "rb-primary-hover": ROUTEBUS.primary,
  "rb-primary-light": "#483A1B",
  "rb-primary-dark": ROUTEBUS.primary,
};

const vuetify = createVuetify({
  components,
  directives,

  defaults: {
    VCard: {
      elevation: 0,
      rounded: "lg",
    },

    VBtn: {
      color: "primary",
      rounded: "lg",
      style: "text-transform: none; letter-spacing: 0;",
    },

    VTextField: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
      hideDetails: "auto",
    },

    VSelect: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
      hideDetails: "auto",
    },

    VTextarea: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
      hideDetails: "auto",
    },

    VAutocomplete: {
      variant: "outlined",
      density: "comfortable",
      color: "primary",
      hideDetails: "auto",
    },

    VCheckbox: {
      color: "primary",
      density: "comfortable",
    },

    VRadioGroup: {
      color: "primary",
    },

    VSwitch: {
      color: "primary",
    },

    VTabs: {
      color: "primary",
    },

    VPagination: {
      color: "primary",
    },
  },

  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },

  theme: {
    defaultTheme: "dark",

    options: {
      customProperties: true,
    },

    themes: {
      light: {
        dark: false,
        colors: { ...lightColors },
      },

      dark: {
        dark: true,
        colors: { ...darkColors },
      },

      routebusLight: {
        dark: false,
        colors: { ...lightColors },
      },

      routebusDark: {
        dark: true,
        colors: { ...darkColors },
      },
    },
  },
});

export default vuetify;
